const REDACTED_VALUE = '[REDACTED]';
const SENSITIVE_PARTS = [
  'password', 'passwd', 'passcode', 'pin', 'otp', 'token', 'authorization', 'cookie',
  'secret', 'apikey', 'credential', 'privatekey', 'cardnumber', 'cardno', 'rfid',
  'phone', 'email', 'bankaccount', 'accountnumber',
];

function isSensitiveKey(key) {
  const normalized = String(key || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
  return SENSITIVE_PARTS.some((part) => normalized.includes(part));
}

function redactDetails(value, currentKey = '') {
  if (isSensitiveKey(currentKey)) return REDACTED_VALUE;
  if (value === null || value === undefined) return value;
  if (Array.isArray(value)) return value.map((item) => redactDetails(item));
  if (typeof value === 'object') {
    return Object.entries(value).reduce((result, [key, item]) => {
      result[key] = redactDetails(item, key);
      return result;
    }, {});
  }
  return value;
}

function summarizeDetails(details = {}) {
  const changedFields = new Set();
  [details?.oldValue, details?.newValue].forEach((value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return;
    Object.keys(value).forEach((key) => {
      if (!isSensitiveKey(key)) changedFields.add(key);
    });
  });
  const sorted = Array.from(changedFields).sort();
  return {
    changedFields: sorted,
    changeCount: sorted.length,
    hasDetails: details !== null && details !== undefined
      && (typeof details !== 'object' || Object.keys(details).length > 0),
  };
}

export function presentAuditLog(log = {}) {
  const details = redactDetails(log.details);
  const localSummary = summarizeDetails(details);
  const serverFields = Array.isArray(log.summary?.changedFields)
    ? log.summary.changedFields.filter((key) => !isSensitiveKey(key)).sort()
    : localSummary.changedFields;
  return {
    ...log,
    details,
    summary: {
      ...localSummary,
      ...log.summary,
      changedFields: serverFields,
      changeCount: serverFields.length,
      hasDetails: log.summary?.hasDetails ?? localSummary.hasDetails,
    },
  };
}

export function normalizeAuditResponse(payload = {}) {
  const logs = Array.isArray(payload.data) ? payload.data.map(presentAuditLog) : [];
  const pagination = payload.pagination || {
    total: Number(payload.total || logs.length),
    page: Number(payload.page || 1),
    limit: 20,
    pages: Number(payload.pages || 1),
  };
  return {
    logs,
    pagination: {
      total: Number(pagination.total || 0),
      page: Number(pagination.page || 1),
      limit: Number(pagination.limit || 20),
      pages: Math.max(Number(pagination.pages || 1), 1),
    },
  };
}

export { REDACTED_VALUE, redactDetails };
